/**
 * Utility functions for managing onboarding completion state.
 * Centralizes localStorage access and event dispatching to follow DRY principles.
 */

/**
 * Marks onboarding as completed and dispatches an event to trigger tab onboarding.
 * This function should be called whenever a user successfully completes the onboarding flow.
 * Only dispatches the event once - subsequent calls are no-ops to prevent duplicate overlays.
 *
 * @throws Does not throw - errors are logged to console
 */
export const completeOnboarding = (): void => {
  try {
    // Only dispatch event if not already completed to prevent duplicate tab onboarding overlays
    const wasAlreadyCompleted = localStorage.getItem('hasCompletedOnboarding') === 'true';
    localStorage.setItem('hasCompletedOnboarding', 'true');

    if (!wasAlreadyCompleted) {
      // Dispatch custom event to trigger tab onboarding in same session
      window.dispatchEvent(new Event('onboardingCompleted'));
    }
  } catch (e) {
    console.warn('Error setting hasCompletedOnboarding in localStorage:', e);
  }
};
